(function () {
  'use strict';

  var sections = document.querySelectorAll('.iceshock-final-cta');
  if (!sections.length) return;

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  sections.forEach(function (section) {
    var revealEls = section.querySelectorAll('.iceshock-final-cta__reveal');

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-delay'), 10) || 0;

          window.setTimeout(function () {
            el.classList.add('is-visible');
          }, delay * 90);

          observer.unobserve(el);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -60px 0px',
      }
    );

    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  });
})();